import React from "react";
import { createRoot } from "react-dom/client";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import Root from "./components/Registration/Root";
import Home from "./components/Registration/Home";
import Wdsf from "./components/Registration/FromWdsf";
import WdsfSolo from "./components/Registration/WdsfSolo";
import WdsfCouple from "./components/Registration/WdsfCouple";
import WdsfTeam from "./components/Registration/WdsfTeam";
import Categories from "./components/Registration/Categories";
import Events from "./components/Registration/Events";

import Validation from "./components/Registration/Validation";
import Modify from "./components/Registration/Modify";

// import Edit from "./components/Registration/Edit";
// import FromOld from "./components/Registration/FromOld";
import * as Sentry from "@sentry/react";
import { HashRouter, Routes, Route } from "react-router-dom";
import Starters from "./components/Registration/Starters";
import Person from "./components/Registration/Person";
import FromForm from "./components/Registration/FromForm";
import FormCouple from "./components/Registration/FormCouple";
import FormSolo from "./components/Registration/FormSolo";
import FormTeam from "./components/Registration/FormTeam";

Sentry.init({
    dsn: "https://1758110291c1d76fbf83e37d019b078f@o294580.ingest.us.sentry.io/4506098071764992",
    integrations: [new Sentry.Integrations.Breadcrumbs({ console: false })],
    // integrations: [new Sentry.BrowserTracing()],

    tunnel: `${window.location.origin}/tunnel`,

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 0.5,

});
const container = document.getElementById("root");
const root = createRoot(container);
const { baseUri } = window.APP_PROPS.itemOptions;
const darkTheme = createTheme({
    palette: {
        mode: "dark"
    }
});

root.render(
    <Sentry.ErrorBoundary fallback={<div className="alert alert-danger">An Error has occurred. Please contact administrator.</div>}>
        <ThemeProvider theme={darkTheme}>
            {/* <CssBaseline /> */}
            <HashRouter>
                <Routes>
                    <Route path="/" element={<Root {...window.APP_PROPS} />}>
                        <Route index element={<Home {...window.APP_PROPS} />} />
                        <Route path="wdsf" element={<Wdsf {...window.APP_PROPS} />} />
                        <Route path="wdsfSolo" element={<WdsfSolo {...window.APP_PROPS} />} />
                        <Route path="wdsfCouple" element={<WdsfCouple {...window.APP_PROPS} />} />
                        <Route path="wdsfTeam" element={<WdsfTeam {...window.APP_PROPS} />} />
                        <Route path="hobby" element={<FromForm {...window.APP_PROPS} hobby={true} />}>
                            <Route path=":code" element={<FromForm {...window.APP_PROPS} hobby={true} />} />
                        </Route>
                        <Route path="starters" element={<Starters {...window.APP_PROPS} />}>
                            <Route path=":code" element={<Starters {...window.APP_PROPS} />} />
                        </Route>
                        <Route path="person" element={<Person {...window.APP_PROPS} />} >
                            <Route path=":code" element={<Person {...window.APP_PROPS} />} />

                        </Route>

                        <Route path="open" element={<FromForm {...window.APP_PROPS} hobby={false} />} />
                        <Route path="formCouple" element={<FormCouple {...window.APP_PROPS} />} />
                        <Route path="formSolo" element={<FormSolo {...window.APP_PROPS} />} />
                        <Route path="formTeam" element={<FormTeam {...window.APP_PROPS} />} />

                        <Route path="categories" element={<Categories {...window.APP_PROPS} />} />
                        <Route path="events" element={<Events {...window.APP_PROPS} />}>
                            <Route path=":code" element={<Events {...window.APP_PROPS} />} />
                        </Route>

                        <Route path="validation" element={<Validation {...window.APP_PROPS} />} />
                        <Route path="modify" element={<Modify {...window.APP_PROPS} />} />
                    </Route>

                </Routes>
            </HashRouter>
        </ThemeProvider>
    </Sentry.ErrorBoundary>
);
